import styled from "styled-components";
import { Button as AntButton } from 'antd'
export const StyledInput = styled.input`
  margin-top: 24px;
  width: 46px !important;
  height: 53px !important;
  border-radius: 9px !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "#D9D9D9")} !important;
  text-align: center !important;
  background: #D9D9D9;
  padding-top: 3px;

  font-size: 16px !important;
  font-weight: 600;

  -moz-appearance: textfield;
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  @media screen and (max-width: 380px) {
    width: 30px !important;
    height: 35px !important;
  }
  @media screen and (max-width: 320px) {
    width: 25px !important;
    height: 30px !important;
  }
`;

export const BottomBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`;

export const BottomText = styled(AntButton)`
  /* cursor: pointer; */
  color: #004F9C !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  border: none !important;

  :hover{
    border: none !important;
    color: #004F9C !important;
  }
`;

export const TimeText = styled.div`
  color:  #004F9C;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;


